<template>
    <div class="conditionally-approve-wizard">
        <div v-if="wizardStep === 0" class="edit-condition__attachments assets">
            <div class="assets-summary">
                <div class="asset-rows__container">
                    <h3 class="section--subtitle first">Borrower Funds to Close</h3>
                    <div class="assets-summary__row">
                        <p class="summary-category">Deposits:</p> 
                        <p>{{ $options.filters.formatCurrencyDec(applicationVODTotal) }}</p>
                    </div>
                    <div class="assets-summary__row">
                        <p class="summary-category">Gifts/Grants:</p>
                        <p>{{ $options.filters.formatCurrencyDec(applicationGiftGrantsTotal) }}</p>
                    </div>
                    <div class="assets-summary__row">
                        <p class="summary-category">Other Assets:</p>
                        <p>{{ $options.filters.formatCurrencyDec(applicationOtherAssetsTotal) }}</p>
                    </div>
                    <hr />
                    <div class="assets-summary__row">
                        <p class="summary-category">Total:</p>
                        <k-numeric-input v-model="borrowerFunds" :format="'c2'" :min="0"/>
                    </div>
                    <div class="assets-summary__row">
                        <div class="summary-category"></div>
                        <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1007</p>    
                    </div>
                    <div v-if="isFHA" class="emd__container">
                        <h3 class="section--subtitle first">Borrower Source of Funds</h3>
                        <k-dropdown class="borrower-funds__dropdown" :data-items="borrowerSourceOfFundsSelects" v-model="condlApprovalFields.find(f => f.id === '34').value"></k-dropdown> 
                    </div>
                    <div class="emd__container">
                        <h3 class="section--subtitle first">Monthly Payment</h3>
                        <div class="assets-summary__row">
                            <p class="summary-category">Total:</p>
                            <k-numeric-input v-model="monthlyPaymentTotal" :format="'c2'" :min="0"/>    
                        </div>
                        <div class="assets-summary__row">
                            <div class="summary-category"></div>
                            <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1029</p>    
                        </div>
                    </div>
                    <div class="emd__container" v-if="!isRefi">
                        <h3 class="section--subtitle first">Earnest Money Deposit</h3>
                        <div class="assets-summary__row">
                            <p class="summary-category">Total:</p>
                            <k-numeric-input v-model="emd" :format="'c2'" :min="0"/>    
                        </div>
                        <div class="assets-summary__row">
                            <div class="summary-category"></div>
                            <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1010</p>    
                        </div>
                    </div>
                    <div class="emd__container" v-if="!isRefi">
                        <h3 class="section--subtitle first">Seller Contribution</h3>
                        <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '4795')">
                            <p class="summary-category">Non-Specific Credit:</p>
                            <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '4795').value) }}</p>
                        </div>
                        <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '202')">
                            <p class="summary-category">Seller Credit:</p>
                            <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '141').value) }}</p>
                        </div>
                        <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '1091')">
                            <p class="summary-category">Seller Credit:</p>
                            <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '1095').value) }}</p>
                        </div>
                        <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '1106')">
                            <p class="summary-category">Seller Credit:</p>
                            <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '1115').value) }}</p>
                        </div>
                        <div class="assets-summary__row" v-if="sellerContributionFields.find(field => field.fieldId === '1646')">
                            <p class="summary-category">Seller Credit:</p>
                            <p>{{ $options.filters.formatCurrencyDec(sellerContributionFields.find(field => field.fieldId === '1647').value) }}</p>
                        </div>
                        <hr />
                        <div class="assets-summary__row">
                            <p class="summary-category">Total:</p>
                            <k-numeric-input v-model="sellerContTotal" :format="'c2'" :min="0"/>    
                        </div>
                        <div class="assets-summary__row">
                            <div class="summary-category"></div>
                            <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1014</p>    
                        </div>
                    </div>
                    <div class="emd__container">
                        <div class="liabilities-title-btn__container">
                            <h3 class="section--subtitle first">Liabilities To Be Paid</h3>
                            <k-button @click="toggleLiabilitiesDialog"><i class="fa-duotone fa-layer-group" title="View Liabilities"></i></k-button>
                        </div>
                        <div class="assets-summary__row" v-for="vol in applicationVOLsToBePaid" v-bind:key="vol.id">
                            <p class="summary-category">{{ vol.holderName }}</p>
                            <p>{{ $options.filters.formatCurrencyDec(vol.toBePaidOffAmount) }}</p>
                        </div>
                        <hr />
                        <div class="assets-summary__row">
                            <p class="summary-category">Total:</p>
                            <k-numeric-input v-model="applicationVOLsToBePaidTotal" :format="'c2'" :min="0"/>
                        </div>
                        <div class="assets-summary__row">
                            <div class="summary-category"></div>
                            <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1032</p>    
                        </div>
                    </div>
                    <div v-if="isFHA" class="emd__container">
                        <h3 class="section--subtitle first">Assets Miniumum Contribution</h3>
                        <div class="assets-summary__row">
                            <p class="summary-category">Total:</p>
                            <k-numeric-input v-model="assetsMinimumTotal" :format="'c2'" :min="0"/>    
                        </div>
                        <div class="assets-summary__row">
                            <div class="summary-category"></div>
                            <p class="asset--info"><span class='k-icon k-i-information k-i-info'></span> Total transfers to *CL1001</p>    
                        </div>
                    </div>
                </div>
            </div>
            <div class="assets-detail">
                <div class="assets__container">
                    <h2 class="section--title">Verification of Deposits</h2>
                    <k-grid :data-items="applicationVODItems" 
                        :data-item-key="'itemNumber'"
                        :columns="VODColumns">
                    </k-grid>
                    <div class="assets-total__container">
                        <p><span>Total:</span> {{ $options.filters.formatCurrencyDec(applicationVODTotal) }}</p>
                    </div>
                </div>

                <div class="assets__container">
                    <h2 class="section--title">Verification of Gifts and Grants</h2>
                    <k-grid :data-items="applicationGiftGrants"
                        :data-item-key="'itemNumber'"
                        :columns="giftGrantsColumns">
                    </k-grid>
                    <div class="assets-total__container">
                        <p><span>Total <i>(Less Deposited)</i>:</span> {{ $options.filters.formatCurrencyDec(applicationGiftGrantsTotal) }}</p>
                    </div>
                </div>

                <div class="assets__container">
                    <h2 class="section--title">Verification of Other Assets</h2>
                    <k-grid :data-items="applicationOtherAssets"
                        :data-item-key="'id'"
                        :columns="otherAssetsColumns">
                    </k-grid>
                    <div class="assets-total__container">
                        <p><span>Total <i>(Less Earnest Money)</i>:</span> {{ $options.filters.formatCurrencyDec(applicationOtherAssetsTotal) }}</p>
                    </div>
                </div>
            </div>
            <div class="conditions__loader-container" v-if="isLoadingBorrowerFunds">
                <loader :size="'large'" :type="'infinite-spinner'"></loader>
            </div>
        </div>

        <div v-if="wizardStep === 1" class="processor-notes__container">
            <div class="processor-select__container" v-if="wizardStep === 1">
                <p class="processor--info">
                    <span class="k-icon k-i-information k-i-info"></span> 
                    Listed below is the current processor on the file. You have the ability to reassign to a different processor using the dropdown below as necessary
                </p>
                <h3 class="step--label">Current Assigned Processor</h3>
                <k-dropdown :data-items="filteredProcessors"
                    :text-field="'displayName'"
                    :data-item-key="'id'"
                    :value="selectedProcessor"
                    :filterable="true"
                    @filterchange="onProcessorFilterChange"
                    @change="onProcessorSelected"></k-dropdown>
                <k-fade :appear="selectedProcessor !== null" v-bind:class="['processor-info__container', {'container--hide': !selectedProcessor }]" >
                    <div v-if="selectedProcessor">
                        <h3 class="step--label"><span class="k-icon k-i-user"></span>  {{ selectedProcessor.fullName }}</h3>
                        <p class="processor__link">Email: <a :href="'mailto: ' + selectedProcessor.email">{{ selectedProcessor.email }}</a></p>
                        <p v-bind:class="['processor__link', { 'processor__link--disabled': !selectedProcessor.cellPhone }]">Mobile: <a :href="selectedProcessor.cellPhone ? 'tel: ' + selectedProcessor.cellPhone : ''">{{ selectedProcessor.cellPhone ? $options.filters.phoneFilter(selectedProcessor.cellPhone) : 'N/A' }}</a></p>
                        <p v-bind:class="['processor__link', { 'processor__link--disabled': !selectedProcessor.phone }]">Phone: <a :href="selectedProcessor.phone ? 'tel: ' + selectedProcessor.phone : ''">{{ selectedProcessor.phone ? $options.filters.phoneFilter(selectedProcessor.phone) : 'N/A' }}</a></p>
                    </div>
                </k-fade>
            </div>  
            <loan-notes-component :loan-id="loanId" 
                    :wizard-view="true"
                    :default-note="'Conditions Updated'"
                    v-on:wizardnoteadded="addWizardNote"></loan-notes-component>
        </div> 

        <div class="review-save__container" v-if="wizardStep === 2">
            <h3 class="step--label">New Notes Added</h3>
            <div class="notes__container">
                <div v-for="note in addedNotes" :key="note" class="note">
                    <blockquote v-html="note"></blockquote>
                </div>
                <div v-if="addedNotes.length === 0">
                    <p class="no-notes">No disposition notes available</p>
                </div>
            </div>
            <h3 class="step--label">Processor</h3>
            <div class="save__container">
                <k-input :value="selectedProcessor?.fullName" disabled></k-input>
            </div>
        </div>

        <div class="conditions__loader-container" v-if="isLoading">
            <loader :size="'large'" :type="'infinite-spinner'"></loader>
        </div>


        <transition name="dialogfade">
            <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
                <p class="error-dialog__msg">{{ errorMsg }}</p>
            </k-dialog>
        </transition>   

        <wizard-liabilities-dialog :show-dialog="showLiabilitiesDialog"
                                    :vols="applicationVOLs"
                                    :loan-id="loanId"
                                    @dialogclosed="toggleLiabilitiesDialog"></wizard-liabilities-dialog>
    </div>
</template>

<script>
    import auth from '../authConfig.js';
    import apiService from '../api/api.service.js';

    import cloneDeep from 'lodash.clonedeep';

    import { Dialog, DialogActionsBar, Window } from '@progress/kendo-vue-dialogs';
    import { DropDownList } from '@progress/kendo-vue-dropdowns';
    import { Loader } from "@progress/kendo-vue-indicators";
    import { Button } from '@progress/kendo-vue-buttons';
    import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
    import { Input, NumericTextBox } from '@progress/kendo-vue-inputs';
    import { Fade } from "@progress/kendo-vue-animation";

    import { filterBy } from '@progress/kendo-data-query';

    import loanNotesComponent from './loanNotesComponent.vue';
    import wizardLiabilitiesDialog from './wizardLiabilitiesDialog.vue';

    export default {
        props: ['earnestMoneyDeposit', 'fields', 'finishClicked', 'isRefi', 'loanId', 'loanType', 'loanVOLs', 'sellerContributionFields', 'sellerContributionTotal', 'wizardStep'],
        emits: ['loanconditionallyapproved', 'processorselected', 'requestfailed', 'setcurrentstepcleared'],
        data() {
            return {
                addedNotes: [],
                applicationGiftGrants: [],
                applicationGiftGrantsTotal: 0,
                applicationId: sessionStorage.getItem('applicationid'),
                applicationOtherAssets: [],
                applicationOtherAssetsTotal: 0,
                applicationVODs: [],
                applicationVODItems: [],
                applicationVODTotal: 0,
                applicationVOLs: [],
                applicationVOLsToBePaid: [],
                applicationVOLsToBePaidTotal: 0,
                approvalMilestone: {},
                assetsMinimumCondition: null,
                assetsMinimumTotal: null,
                borrowerEMDCondition: null,
                borrowerFunds: 0,
                borrowerFundsCondition: null,
                borrowerSourceOfFundsSelects: ['Bridge Loan', 'Cash On Hand', 'Checking/Savings', 'Deposit On Sales Contract', 'Equity On Pending Sale', 'Equity On Sold Property', 'Equity On Subject Property', 'Gift Funds', 'Life Insurance Cash Value',
                    'Lot Equity', 'Other Type Of Down Payment', 'Rent With Option To Purchase', 'Retirement Funds', 'Sale Of Chattel', 'Secured Borrowed Funds', 'Stocks And Bonds', 'Sweat Equity', 'Trade Equity', 'Trust Funds',
                    'Unsecured Borrowed Funds', 'FHA - Gift - Source N/A', 'FHA - Gift - Source Relative', 'FHA - Gift - Source Government Assistance', 'FHA - Gift - Source Nonprofit/Religious/Community - Seller Funded', 
                    'FHA - Gift - Source Nonprofit/Religious/Community - Non-Seller Funded', 'FHA - Gift - Source Employer'],
                conditionTemplates: [],
                condlApprovalFields: [
                    { label: '', value: null, id: '34', type: 'dropdown', iterate: false }
                ],
                condlApprovalFieldsList: ['34'],
                condlApprovalMilestone: {},
                emd: null,
                errorMsg: '',
                errorTitle: '',
                filteredProcessors: [],
                giftGrantsColumns: [
                    { field: 'assetType', title: 'Type' },
                    { field: 'owner', title: 'Belong To' },
                    { field: 'source', title: 'Source' },
                    { field: 'deposited', title: 'Deposited' },
                    { field: 'amount', title: 'Total', format: '{0:c2}' }
                ],
                isLoading: false,
                isLoadingBorrowerFunds: false,
                liabilitiesToBePaidCondition: null,
                loanData: null,
                milestones: [],
                monthlyPaymentCondition: null,
                monthlyPaymentTotal: 0,
                otherAssetsColumns: [
                    { field: 'holderName', title: 'Title' },
                    { field: 'borrowerType', title: 'Belong To' },
                    { field: 'assetType', title: 'Type' },
                    { field: 'otherDescription', title: 'Description' },
                    { field: 'cashOrMarketValue', title: 'Total', format: '{0:c2}' }
                ],
                processors: [],
                resubmittalMilestone: {},
                roleId: '',
                selectedProcessor: null,
                sellerContributionCondition: null,
                sellerContTotal: 0,
                showErrorDialog: false,
                showLiabilitiesDialog: false,
                VODColumns: [
                    { field: 'bank', title: 'Bank' },
                    { field: 'owner', title: 'Belong To' },
                    { field: 'type', title: 'Account Type' },
                    { field: 'accountIdentifier', title: 'Account Number' },
                    { field: 'cashOrMarketValueAmount', title: 'Total', format: '{0:c2}' }
                ]
            }
        },
        computed: {
            isFHA() {
                return this.loanType === 'FHA';
            }
        },
        watch: {
            wizardStep(val) {
            },
            finishClicked(val) {
                if (val) {
                    this.dispositionLoan();
                }
            }
        },
        async mounted() {
            this.getMilestones();
            this.getBorowerFundsToClose();
            this.getEncompassUsers();

            if (this.isFHA) {
                this.getCondlApprovalFields();
            }

            await this.assignClosingConditions();
        },
        methods: {
            addWizardNote(noteHtml) {
                this.addedNotes.push(noteHtml);
            },
            async assignClosingConditions() {
                if (!this.isRefi) {
                    this.emd = +this.earnestMoneyDeposit;

                    await this.assignOrCreateClosingCondition('*CL1010 - Closing - EMD', 'borrowerEMDCondition');

                    this.sellerContTotal = this.sellerContributionTotal;

                    await this.assignOrCreateClosingCondition('*CL1014 - Closing - Seller Contribution', 'sellerContributionCondition');
                }

                await this.assignOrCreateClosingCondition('*CL1007 - Closing - Borrower(s) cash to close cannot exceed $', 'borrowerFundsCondition');

                if (this.isFHA) {
                    await this.assignOrCreateClosingCondition('*CL1001 - Closing - Assets Minimum Contribution', 'assetsMinimumCondition');
                    let purchasePrice = sessionStorage.getItem('purchaseprice');

                    if (purchasePrice && purchasePrice > 0) {
                        this.assetsMinimumTotal = +((purchasePrice * 0.035).toFixed(2));
                    } else {
                        this.assetsMinimumTotal = 0;
                    }
                }

                this.loanProgram = sessionStorage.getItem('loanprogram');

                await this.assignOrCreateClosingCondition('*CL1029 -Closing - Monthly payment including taxes,HOA,  insurance, MI not to exceed $', 'monthlyPaymentCondition');

                let monthlyPayment = this.fields.find(field => field.fieldId === '912');

                if (monthlyPayment?.value && this.monthlyPaymentCondition) {
                    this.monthlyPaymentTotal = +monthlyPayment.value + 50;
                }

                let loanData = sessionStorage.getItem('loandata');

                if (loanData) {
                    this.loanData = JSON.parse(loanData);
                }

                this.applicationVOLs = this.loanVOLs;

                this.applicationVOLs.forEach(vol => {
                    vol.liabilityType = this.formatPascalValue(vol.liabilityType);
                    vol.toBePaidOff = vol.payoffIncludedIndicator ? 'Y' : 'N';
                });

                this.applicationVOLsToBePaid = this.loanVOLs.filter(vol => vol.payoffIncludedIndicator);

                await this.assignOrCreateClosingCondition('*CL1032 - Closing Debts to be paid on CD', 'liabilitiesToBePaidCondition');

                this.applicationVOLsToBePaidTotal = this.applicationVOLsToBePaid.reduce((prev, cur) => {
                    return prev + cur.toBePaidOffAmount;
                }, 0);
            },
            assignFHASummarySelects(fieldId) {
                switch (fieldId) {
                    case '34':
                        this.borrowerSourceOfFundsSelects.sort();
                        this.borrowerSourceOfFundsSelects.unshift('Select Option');
                        return this.borrowerSourceOfFundsSelects;
                    default:
                        return this.yesNoDropdownSelects;
                }
            },
            async assignOrCreateClosingCondition(conditionName, prop) {
                this[prop] = this.$store.state.conditions.find(cond => cond.title === conditionName);

                if (!this[prop]) {
                    if (this.conditionTemplates.length === 0) {
                        if (this.$store.state.conditionTemplates.length === 0) {
                            await this.$store.dispatch('getConditionTemplates');
                        }
                    }

                    this.conditionTemplates = cloneDeep(this.$store.state.conditionTemplates);

                    let template = this.conditionTemplates.find(cond => cond.title === conditionName);

                    if (template) {
                        let newCondition = cloneDeep(template);

                        newCondition.externalDescription = newCondition.externalDescription ?? "";
                        newCondition.internalDescription = newCondition.internalDescription ?? "";
                        newCondition.priorTo = newCondition.priorTo ?? "";
                        newCondition.bySwift = true;

                        await this.$store.dispatch('addCondition', newCondition);
                        await this.$store.dispatch('getConditions');

                        this[prop] = this.$store.state.conditions.find(cond => cond.title === conditionName);
                    }
                } else {
                    this[prop].externalDescription = this[prop].externalDescription ?? "";
                    this[prop].internalDescription = this[prop].internalDescription ?? "";
                    this[prop].priorTo = this[prop].priorTo ?? "";
                }
            },
            assignProcessors(allProcessors) {
                if(allProcessors.length > 0) {
                    let currentProcessor = sessionStorage.getItem('currentprocessor');

                    this.processors = allProcessors.filter(proc => proc.userIndicators.some(indicator => indicator === 'Enabled') || proc.id === currentProcessor).sort((a, b) => a.fullName.localeCompare(b.fullName));
                    this.processors.forEach(proc => proc.displayName = `${proc.fullName}  (${proc.id})`);

                    this.filteredProcessors = cloneDeep(this.processors);

                    this.selectedProcessor = this.filteredProcessors.find(proc => proc.id === currentProcessor);
                    this.$emit('processorselected', true);
                }
            },
            async dispositionLoan() {
                if (this.borrowerEMDCondition) {
                    this.borrowerEMDCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.emd).toString());
                }

                if (this.sellerContributionCondition) {
                    this.sellerContributionCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.sellerContTotal).toString());
                }

                if (this.liabilitiesToBePaidCondition) {
                    this.liabilitiesToBePaidCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.applicationVOLsToBePaidTotal).toString());
                }

                if (this.assetsMinimumCondition) {
                    this.assetsMinimumCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.assetsMinimumTotal).toString());
                }

                this.borrowerFundsCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.borrowerFunds).toString());
                
                this.monthlyPaymentCondition.externalDescription = this.$options.filters.formatCurrency(Math.ceil(this.monthlyPaymentTotal).toString());

                let unfinishMilestones = [];

                //check if condl approval is not current milestone, need to unfinish any subsequent milestones first, in order of newest finished, if necessary
                if (this.approvalMilestone.doneIndicator) {
                    unfinishMilestones.push(this.approvalMilestone.id);
                }

                if (this.resubmittalMilestone.doneIndicator) {
                    unfinishMilestones.push(this.resubmittalMilestone.id);
                }

                let request = {
                    loanId: this.loanId,
                    borrowerFundsCondition: this.borrowerFundsCondition,
                    borrowerEMDCondition: this.borrowerEMDCondition,
                    sellerContributionCondition: this.sellerContributionCondition,
                    assetsMinimumCondition: this.assetsMinimumCondition,
                    monthlyPaymentCondition: this.monthlyPaymentCondition,
                    liabilitiesToBePaidCondition: this.liabilitiesToBePaidCondition,
                    resubmittalAssociate: {
                        loanAssociateType: 'User',
                        userId: this.selectedProcessor.id,
                        loanId: this.loanId, 
                        milestoneId: this.resubmittalMilestone.id
                    },
                    condlApprovalId: this.condlApprovalMilestone.id,
                    action: this.condlApprovalMilestone.doneIndicator ? "unfinish" : "finish",
                    unfinishMilestones: unfinishMilestones,
                    isSuspended: sessionStorage.getItem('issuspended') === 'true'
                };

                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                apiService.ConditionallyApproveLoan(request, tokenResponse.accessToken)
                    .then(res => {
                        this.isLoading = false;

                        return this.$emit('loanconditionallyapproved', 'Milestone saved successfully');
                    }).catch(error => {
                        this.errorTitle = 'Failed to Disposition Loan';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                        this.$emit('requestfailed');
                    });
            },
            formatFHAFields(data) {
                //console.log(cloneDeep(data.find(f => f.fieldId === '1639')))
                this.condlApprovalFields.forEach(field => {
                    let match = data.find(item => item.fieldId === field.id);

                    if (match) {
                        if (field.type === 'dropdown' || field.type === 'yesnodropdown') {
                            field.selects = this.assignFHASummarySelects(field.id);

                            if (!match.value) {
                                match.value = 'Select Option';
                            } else {
                                if (field.type === 'yesnodropdown') {
                                    match.value = match.value === 'Y' ? 'Yes' : 'No';
                                } else {
                                    let customMatch = false;

                                    if (field.id === '34' && match.value.includes('Nonprofit')) {
                                        customMatch = true;
                                    }

                                    if (field.id === '34' && customMatch) {
                                        match.value = this.getFHAFundsSourceValue(match.value);
                                    }

                                    if (!customMatch) {
                                        let s = match.value.replace(/[^a-zA-Z0-9]/g, '');
                                        let matchingSelect = field.selects.find(select => select.replace(/[^a-zA-Z0-9]/g, '').toLowerCase() === s.toLowerCase());
                                        
                                        match.value = matchingSelect ?? match.value;
                                    }
                                            
                                }
                            }
                        }

                        if (field.type === 'checkbox' && (match.value === 'Y' || match.value === 'X')) {
                            match.value = 'Y';
                        } 

                        if (field.type === 'numeric') {
                            match.value = +match.value;
                        }

                        if (field.type === 'date') {
                            if (match.value && match.value !== '//') {
                                match.value = new Date(match.value);
                            } else {
                                match.value = null;
                            }

                            if (!match.value && (field.section === 'Commitment Terms' || field.section === 'Approved & Additional Conditions')) {
                                if (field.id === '1072' || field.id === '3177') {
                                    let today = new Date();
                                    today.setDate(today.getDate() + 180);

                                    match.value = today;
                                } else {
                                    match.value = new Date();
                                }
                            }
                        }

                        field.value = match.value;
                    }
                });
            },
            formatPascalValue(val) {
                if (!val) return;

                return val.match(/[A-Z][a-z]+|[0-9]+/g).join(' ');
            },
            async getBorowerFundsToClose() {
                let tokenResponse = await auth.acquireTokenResponse();

                this.isLoadingBorrowerFunds = true;

                apiService.GetBorrowerFundsToClose(this.loanId, this.applicationId, tokenResponse.accessToken)
                    .then(res => {
                        this.applicationVODs = res.data.data.applicationVODs;
                        this.applicationGiftGrants = res.data.data.applicationGiftGrants;
                        this.applicationOtherAssets = res.data.data.applicationOtherAssets;

                        this.processApplicationVODs();
                        this.processApplicationGiftGrants();
                        this.processApplicationOtherAssets(); 

                        this.borrowerFunds = this.applicationGiftGrantsTotal + this.applicationOtherAssetsTotal + this.applicationVODTotal;

                        this.isLoadingBorrowerFunds = false;

                        this.$emit('setcurrentstepcleared', true, 0);
                    }).catch(error => {
                        this.errorTitle = 'Failed to Get Borrower Funds To Close';

                        if(error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getCondlApprovalFields() {
                let tokenResponse = await auth.acquireTokenResponse();

                return apiService.GetLoanFieldList(this.loanId, this.condlApprovalFieldsList, tokenResponse.accessToken)
                    .then(res => {
                        if (this.isFHA) {
                            this.formatFHAFields(res.data.data);
                        }
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Loan Fields';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = 'Please close the disposition menu and try again.';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getEncompassUsers() {
                if (this.processors.length > 0) return this.filteredProcessors = cloneDeep(this.processors);

                this.isLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                apiService.GetProcessors(tokenResponse.accessToken)
                    .then(res => {
                        this.assignProcessors(res.data.data);

                        this.isLoading = false;
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Processors';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            getFHAFundsSourceValue(value) {
                switch(value) {
                    case 'FHAGiftSourceNonprofitSellerFunded':
                        return 'FHA - Gift - Source Nonprofit/Religious/Community - Seller Funded';
                    case 'FHAGiftSourceNonprofitNonSellerFunded':
                        return 'FHA - Gift - Source Nonprofit/Religious/Community - Non-Seller Funded';
                    default:
                        return value;
                };
            },
            async getMilestones(update = false) {
                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                apiService.GetMilestones(this.loanId, tokenResponse.accessToken)
                    .then(res => {
                        if (res.data.data) {
                            this.milestones = res.data.data;

                            this.condlApprovalMilestone = res.data.data.find(milestone => milestone.milestoneName === "Cond'l Approval");
                            this.resubmittalMilestone = res.data.data.find(milestone => milestone.milestoneName === "Resubmittal");
                            this.approvalMilestone = res.data.data.find(milestone => milestone.milestoneName === "Approval");
                        }
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Milestones';
                        
                        if(error.response?.data?.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                        this.$emit('requestfailed');
                    });
            },
            onProcessorFilterChange(evt) {
                this.filteredProcessors = filterBy(this.processors, evt.filter);
            },
            onProcessorSelected(evt) {
                this.selectedProcessor = evt.value;
                this.$emit('processorselected', true);
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.toggleErrorDialog();
            },
            processApplicationGiftGrants() {
                this.applicationGiftGrants.forEach(gg => {
                    gg.deposited = gg.depositedIndicator ? 'Yes' : 'No';
                    gg.assetType = this.formatPascalValue(gg.assetType);
                    gg.source = this.formatPascalValue(gg.source);
                });

                this.applicationGiftGrantsTotal = this.applicationGiftGrants.reduce((prev, cur) => {
                    if (!cur.depositedIndicator) {
                        return prev + cur.amount;
                    }

                    return prev;
                }, 0);
            },
            processApplicationOtherAssets() {
                this.applicationOtherAssets.forEach(asset => {
                    asset.assetType = this.formatPascalValue(asset.assetType);
                });

                this.applicationOtherAssetsTotal = this.applicationOtherAssets.reduce((prev, cur) => {
                    if (cur.assetType !== 'Earnest Money') {
                        return prev + cur.cashOrMarketValue;
                    } 

                    return prev;
                }, 0);
            },
            processApplicationVODs() {
                this.applicationVODItems = [];
                this.applicationVODTotal = 0;

                this.applicationVODs.forEach(vod => {
                    let VODItems = vod.items.map(item => {
                        return {
                            bank: vod.holderName,
                            owner: vod.owner,
                            type: this.formatPascalValue(item.type),
                            cashOrMarketValueAmount: item.cashOrMarketValueAmount + item.urla2020CashOrMarketValueAmount,
                            itemNumber: item.itemNumber,
                            accountIdentifier: item.accountIdentifier
                        }
                    })
                    this.applicationVODItems.push([...VODItems]);

                    this.applicationVODTotal += vod.total;
                });

                this.applicationVODItems = this.applicationVODItems.flat().filter(item => item.cashOrMarketValueAmount > 0 || item.urla2020CashOrMarketValueAmount > 0);
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if (!this.showErrorDialog) {
                    this.errorMsg = '';
                    this.errorTitle = '';
                }
            },
            toggleLiabilitiesDialog() {
                this.showLiabilitiesDialog = !this.showLiabilitiesDialog;
            }
        },
        filters: {
            formatCurrency(val) {
                if (val === null || val === undefined || val === '') return '';

                if (val.toString().includes('$')) return val;

                if (isNaN(val)) {
                    val = 0;
                }

                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });

                return formatter.format(val);
            },
            formatCurrencyDec(val) {
                if (val === null || val === undefined || val === '') return '';

                if (val.toString().includes('$')) return val;

                if (isNaN(val)) {
                    val = 0;
                }

                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                return formatter.format(val);
            },
            phoneFilter(val) {
                if (!val) return '';

                let formattedPhone = val.split(' ').join('').split('-').join('').split('(').join('').split(')').join('');

                if (formattedPhone.length !== 10 && formattedPhone.length !== 11) return '';

                if (formattedPhone.length === 10) {
                    return `(${formattedPhone.substring(0, 3)}) ${formattedPhone.substring(3, 6)}-${formattedPhone.substring(6)}`;
                } else {
                    return `${formattedPhone.substring(0, 1)} (${formattedPhone.substring(1, 4)}) ${formattedPhone.substring(4, 7)}-${formattedPhone.substring(7)}`;
                }
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'loan-notes-component': loanNotesComponent,
            'loader': Loader,
            'k-button': Button,
            'k-dropdown': DropDownList,
            'k-input': Input,
            'k-fade': Fade,
            'k-numeric-input': NumericTextBox,
            'k-grid': Grid,
            'toolbar': GridToolbar,
            'wizard-liabilities-dialog': wizardLiabilitiesDialog
        }
    }
</script>

<style>
    @import '/src/assets/css/conditionallyApproveWizard.css';
</style>